/* @flow */

module.exports = {
  "LOCALE": {
    "CURRENCY": "DKK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "",
  },
  "META": {
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=1600988e7224b21600988e7224e9",
  },
  "SKIP_TO_CONTENT": "Gå til indhold",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "LOGO": {
    "ALT": "Zupergift.com",
    "TITLE": "Hjem",
  },
  "CLOSE_SYSTEM_MESSAGE": "Luk besked",
  "COOKIE_CONSENT": {
    "ALL": "Tillad alle ",
    "SELECTED": "Tillad valg",
    "NECESSARY": "Kun nødvendige",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "ROUTES": {
    "ALL_GIFTCARDS": "/alle-gavekort",
  },
  "HOMEVIEW": {
    "POPULAR_BRANDS": "Populære brands",
    "POPULAR_CATEGORIES": "Populære kategorier",
    "POPULAR_PRODUCTS": "Populære gavekort",
    "ALL_CATEGORIES": "Alle kategorier",
    "MORE_POPULAR_PRODUCTS": "Flere populære produkter",
    "TUTORIAL": "Sådan fungerer det",
  },
  "COMPANYVIEW": {
    "HERO": {
      "TITLE": "Gavekort til virksomheder",
      "CONTENT": "Digitale gavekort, der gør firmagaver enkle. I vælger beløbet – modtageren vælger selv blandt hundredvis af kendte brands. En fleksibel løsning, der sparer tid og styrker relationer.",
      "LIST_ITEM_1": "Hurtig digital levering",
      "LIST_ITEM_2": "100+ kendte brands",
      "LIST_ITEM_3": "Tryg håndtering med personlig support",
    },
    "POPULAR_TITLE": "Populære brands du finder hos os",
    "CTA_1": "Tilbudsanmodning",
    "CTA_LINK_1": "https://2dd4ic.share-eu1.hsforms.com/2wBFM1jZjTIaiurEOi1TAJA",
    "CTA_2": "Kontakt os",
    "CTA_LINK_2": "https://helpdesk.crossroads.se/?s=15e4e4fcc649e015e4e4fcc64a16",
    "FIELD_1": {
      "TITLE": "Digitale gavekort fra 100+ kendte brands",
      "TEXT_CONTENT": "Giv modtageren friheden til selv at vælge fra et bredt udvalg inden for mode, sport, elektronik, rejser og oplevelser. Perfekt til julegaver, bonus, incitamenter og kampagner, hvor I vil skabe reel motivation. Nemt at sende. Lille indsats. Stor effekt.",
      "CTA": "Se udvalg",
      "CTA_LINK": "/alle-gavekort",
    },
    "FIELD_2": {
      "TITLE": "Sådan fungerer vores firmagaver",
      "LIST_ITEM_1": "1. Opret firmakonto",
      "LIST_ITEM_2": "2. Tilføj brugere",
      "LIST_ITEM_3": "3. Anmod om faktura",
      "LIST_ITEM_4": "4. Kontoen fyldes op",
      "LIST_ITEM_5": "5. Send gavekort ud",
      "LIST_ITEM_6": "6. Se samlet statistik i portalen",
    },
  },
  "TUTORIAL": {
    "STEP_1": {
      "TITLE": "1",
      "TEXT": "Køb Zupergift ",
      "LINK": "/zupergift",
    },
    "STEP_2": {
      "TITLE": "2",
      "TEXT": "Levering direkte på e-mail",
    },
    "STEP_3": {
      "TITLE": "3",
      "TEXT": "Indløs Zupergift ",
      "LINK": "/redeem",
    },
    "STEP_4": {
      "TITLE": "4",
      "TEXT": "Vælg gavekort",
      "LINK": "/alle-gavekort",
    },
  },
  "REDEEM": {
    "HEADING": "Indløs dit gavekort",
    "CLOSE": "Luk",
    "TEXT": "Start med at indtaste din kode nedenfor. Du finder koden i e-mailen, der indeholder dit Zupergift-gavekort. I det næste trin vælger du, hvilket eller hvilke brands du vil indløse dit gavekort til. Derefter går du til kassen, også lander dit valg af gavekort i din e-mail. Zuper enkelt!",
    "PLACEHOLDER_CODE": "Indtast kode",
    "PLACEHOLDER_PIN": "Indtast PIN-kod",
    "SUBMIT": "Spara",
    "SUCCESS_ROUTE": "/alle-gavekort",
    "HOWTO": {
      "CODE": "Indtast din værdikode",
      "BALANCE": "Se din saldo",
      "SELECT": "Vælg gavekort",
      "DELIVERY": "Levering via e-mail",
    },
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Efternavn",
    "STREET_1": "Adresse 1",
    "STREET_2": "Adresse 2 (valgfri)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikel %current af %total",
    "CONTROLS": {
      "LABEL": "Navigation for karrusel",
      "PREV_ITEM_GROUP_LABEL": "Forrige artikelgruppe",
      "NEXT_ITEM_GROUP_LABEL": "Næste artikelgruppe",
      "GO_TO_ITEM_GROUP_LABEL": "Gå til artikelgruppe %number",
      "PLAY_LABEL": "Start automatisk afspilning",
      "PAUSE_LABEL": "Sæt automatisk afspilning på pause",
    },
  },
  "DIALOGUE": {
    "CLOSE": "Luk dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Luk banner",
  },
  "OR": "eller",
  "CART": {
    "CLOSE": "Luk kurven",
    "HEADING": "Indkøbskurv",
    "TOTALS": "Totalt",
    "YOUR_BALANCE": "Din saldo",
    "AFTER_PURCHASE": "Saldo efter køb",
    "VALID_TO": "Gyldig indtil",
    "PAY_VOUCHER": "Gavekort",
    "EMPTY": "Indkøbskurven er tom",
    "INCREMENT": "Øg antal",
    "DECREMENT": "Reducere antal",
    "QUANTITY": "Antal",
    "NAV_BUTTON": "Gå til kurven, der er %amount produkt(er)",
    "CTA": "Gå til indkøbskurven",
    "PRODUCTS": "Produkter",
    "SHIPPING": "Fragt",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå til kassen",
    "DIALOG_CANCEL": "Luk",
    "REMOVE_PRODUCT": "Fjern produkt",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra indkøbskurven?",
    "CONTINUE_SHOPPING": "Fortsæt med at handle",
    "DISCOUNT": "Rabat",
    "SUB_TOTAL": "Beløb",
    "GRAND_TOTAL": "Total",
    "CLOSE_SUMMARY": "Luk oversigten",
    "OPEN_SUMMARY": "Åbn oversigten",
    "SUBMIT": "Gem antal produkter",
  },
  "CHECKOUT": {
    "TITLE": "Kasse",
    "CONTINUE": "Forsæt",
    "TO_PAYMENT": "Gå til betaling",
    "AMOUNT_TO_PAY": "At betale",
    "EDIT": "Ændre",
    "BACK_TO_CART_TEXT": "Tilbage til indkøbskurven",
    "COMPLETE_PURCHASE": "Afslut køb",
    "REDEEM_LABEL_CODE": "Gavekortkode",
    "REDEEM_LABEL_PIN": "Indtast tilhørende pinkode",
    "REDEEM_SUBMIT": "Brugt",
    "OPT_EMAIL": "Jeg vil gerne have information om tilbud fra Zupergift",
    "I_ACCEPT_THE": "Jeg accepterer",
    "TERMS": "købsbetingelserne",
    "TERMS_URL": "handelsbetingelser",
    "TERMS_CLOSE": "Luk betingelser",
    "PAYMENT_METHOD_STEP": "Vælg betalingsmetode",
    "PAY_STEP": "Gå til sikker betaling",
    "ADDRESS": {
      "ADDRESS": "Faktura- og leveringsoplysninger",
      "SHIPPING": "Leveringsadresse",
      "SHIP_TO_SAME_ADDRESS": "Leveret til samme adresse",
    },
    "DISCOUNT_CODE": {
      "HEADER": "Rabatkode",
      "PLACEHOLDER": "Indtast kode",
      "APPLY": "Anvend",
      "REMOVE": "Fjerne",
    },
  },
  "PAYMENT_METHODS": {
    "ALTAPAY": {
      "CARD": "Betal med kort",
    },
  },
  "SUCCESS": {
    "TITLE": "Ordre registreret",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Forsæt med at handle",
    "NOT_FOUND_TITLE": "Ingen ordre fundet.",
    "NOT_FOUND_SUBTITLE": "Kontakt kundeservice, hvis dette er forkert.",
    "WHAT_NOW": "Så hvad sker der nu?",
    "STEPS": {
      "HEADING": "Ordre registreret",
      "WHAT_NOW": "Så hvad sker der nu?",
      "LABEL": "Din ordre",
      "ORDER_ID": "Ordrenummer %id",
      "QUESTIONS": {
        "HEADING": "Har du et spørgsmål om din ordre?",
        "LABEL": "Gå til kundtservice",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse vil  blive sendt til %email.",
        },
        "2": {
          "HEADING": "Behandler",
          "TEXT": "Din ordre sendes, når alle produkter er tilgængelige for levering. Dette sker som regel den næste dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er pakket og sendt, får du besked via e-mail. I leveringsbekræftelsen finder du et sporingslink, så du kan følge pakken. Leveringen tager normalt 1-2 dage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Nogle pakker leveres direkte til din postkasse. Pakker, der er for store, leveres i stedet til et leveringssted og du meddeles via SMS til det mobilnummer, du har angivet i ordren. Pakker ligger på leveringsstedet i 14 dage.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse og dine digitale billetter/værdikoder vil snart blive sendt til %email. Hvis du ikke har modtaget nogen e-mail, kontrollere venligst dit spamfilter, før du kontakter kundeservice.",
        },
        "2": {
          "HEADING": "Behandler",
          "TEXT": "Din ordre sendes, når alle produkter er tilgængelige for levering. Dette sker som regel den næste dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er pakket og sendt, får du besked via e-mail. I leveringsbekræftelsen finder du et sporingslink, så du kan følge pakken. Leveringen tager normalt 1-2 dage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Vi sender dine digitale billetter/værdikoder til %email. Din fysiske levering sendes med DBSchenker. Nogle pakker leveres direkte til din postkasse. Pakker, der er for store, leveres i stedet til et leveringssted og du meddeles via SMS til det mobilnummer, du har angivet i ordren. Pakker ligger på leveringsstedet i 14 dage.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "Du modtager en ordrebekræftelse til %email",
        },
        "2": {
          "HEADING": "Digital levering",
          "TEXT": "Vi sender dine digitale billetter/værdikoder til %email. Hvis du ikke har modtaget nogen e-mail, kontrollere venligst dit spamfilter, før du kontakter kundeservice.",
        },
      },
    },
    "CONTACT": {
      "TITLE": "Har du nogle spørgsmål?",
      "INFO": "Vi besvarer dine spørgsmål vedrørende levering, produkter eller sortimentet inden for 48 timer på hverdage.",
      "CREATE_TICKET": "Skriv til os via vores kontaktformular",
    },
  },
  "CATEGORY": {
    "EMPTY": "Der er ingen produkter at vise lige nu",
    "LOAD_MORE": "Indlæs mere",
    "PRODUCTS_IN_CATEGORY_TITLE": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
  },
  "ALL_GIFTCARDS": {
    "TITLE": "Alla gavekort",
  },
  "404": {
    "TITLE": "Siden kunne ikke findes",
    "HEADING": "— 404 —",
    "SUBHEADING": "Siden kunne ikke findes",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfejl",
    "TEXT": "<strong> Har du brug for at kontakte os? </strong> <br/> Send en e-mail til <a href=\"mailto:kundservice@crossroads.se\"> kundservice@crossroads.se </a>",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søg: ",
    "PLACEHOLDER": "Søg efter et gavekort",
    "PRODUCTS_IN_SEARCH_RESULT": "Fundet %itemsCount matchende produkter",
    "PRODUCT_IN_SEARCH_RESULT": "Fundet en matchende produkt",
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alla filtre",
      "FILTER_BY_POINTS": "Filtrer på point",
      "FILTER_BY_PRICE": "Filtrer på pris",
      "PRICE_RANGE": "%min - %max kr",
      "SORT": "Sortere",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Navn ↓",
      "SORT_NAME_ASC": "Navn  ↑",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Vis resultat",
      "CLOSE_MENU": "Luk filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Ryd filtre",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filtree",
      "PRICE_RANGE": "Pris (%range)",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrer på point",
      "FILTER_BY_POINTS": "Filtrer på pris",
      "RESET_PRICE": "Ryd filtre",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
    },
  },
  "HEADER": {
    "MAIN_NAVIGATION": "Hovedmenu",
    "OPEN_MENU": "Åbn menuen",
    "CLOSE_MENU": "Luk menu",
    "BACK": "Gå tilbage",
    "SEARCH": "Søg",
    "OPEN_SEARCH": "Åbn søgning",
    "CLOSE_SEARCH": "Luk søgning",
    "ALL_GIFTCARDS": "Alle gavekort",
    "BUY_ZUPERGIFT": "Køb Zupergift",
    "REDEEM_GIFTCARD": "Indløs din Zupergift",
    "CATEGORIES": "Kategorier",
    "COMPANY": "Forretning",
    "CART": "Indkøbskurv",
    "HELP": "Kontakt",
    "ABOUT": "Hvordan fungerer det?",
    "CLOSE_CATEGORIES": "Lik kategorier",
  },
  "FOOTER": {
    "NAVIGATION": "Sidefodsmenu",
    "CATEGORIES": "Kategorier",
    "COPYRIGHT": "Copyright © %currentYear",
    "RECAPTCHA": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\">Terms of Service</a> apply.",
    "LANGUAGE_SWITCHER_TEXT": "You're using the Danish version of Zupergift",
    "LANGUAGE_SWITCHER_BUTTON": "Change language/region",
    "COOKIES": "Administrer cookies",
    "TERMS_LINK": "handelsbetingelser",
    "TERMS_TEXT": "Handelsbetingelser",
    "ACCESSIBILITY": "Tilgængelighed",
  },
  "LANGUAGE_SWITCHER": {
    "TITLE": "Welcome!",
    "CLOSE": "Close language switcher",
    "SUB_TITLE": "You're using the Danish version of Zupergift. Do you want to change language/region?",
    "FINLAND": "Finland",
    "DENMARK": "Denmark",
    "NORWAY": "Norway",
    "SWEDEN": "Sweden",
  },
  "BREADCRUMBS": {
    "HOME": "Hjem",
    "HOME_URL": "/",
    "SEARCH_RESULTS_FOR": "Søgeresultater for: ",
  },
  "PRODUCT": {
    "STARTING_AT": "Fra",
    "ADD_TO_CART": "Læg i indkøbskurv",
    "OUT_OF_STOCK": "Udsolgt",
    "DESCRIPTION": "Produktbeskrivelse",
    "RELATED_PRODUCTS": "Relaterede produkter",
    "CROSS_SELL_PRODUCTS": "Andre kan også lide",
    "OPTION_DROPDOWN_PLACEHOLDER": "Vælg et alternativ ...",
    "CHANGE_IMAGE": "BSkift billede",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatorisk felt",
    "EMAIL": "Indtast en gyldig e-mailadresse",
    "PHONE": "Indtast venligst et gyldigt mobilnummer",
    "NUMERIC": "Feltet kan kun indeholde tal",
    "LENGTH_LT": "Feltet indeholder for mange tegn",
    "POSTCODE": "Indtast venligst et korrekt postnummer (XXX XX)",
    "MATCH": "Feltet matcher ikke",
    "MISSING_FIELD": "Manglende adresse. Prøv igen",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "Der er opstået en ukendt fejl. Genindlæs siden, og prøv igen.",
    "NETWORK_ERROR": "Signalet blev afbrudt. Kontroller, at du har en aktiv internetforbindelse eller prøv igen om et øjeblik.",
    "PLACE_ORDER_CATCH": "En fejl opstod. Prøv igen senere.",
    "AQUIRER_DECLINE": "Betalingen er blevet afvist. Bekræft venligst dine kort-/kontooplysninger.",

    "errorFraudShop": "Det er ikke muligt at gennemføre et køb på nuværende tidspunkt.",
    "errorFraudOrder": "Købet er ikke tilladt. Kontakt support for mere information.",
    "errorFraudProduct": "Grænsen er nået for et eller flere produkter i indkøbskurven. Kontakt support for mere information",
    "errorFraudBlacklist": "Købet er ikke tilladt. Kontakt support for mere information",
    "errorDeclinedCard": "Kortet blev afvist.",

    "errorProductQuantityNotAvailable": "Det antal du har indtastet, er ikke tilgængelig i øjeblikket.",
    "errorProductNotInStock": "Det produkt du forsøger at tilføje til kurven, er desværre ikke på lager i øjeblikket.",
    "errorProductMaxQuantity": "Det angivne antal er desværre ikke på lager i øjeblikket.",
    "errorProductNotChosenVariant": "Vælg %attributeLabel for at kunne tilføje produkter til din indkøbskurv.",
    "errorBillingAddressValidationFailed": "Forkert adresse",
    "errorInvalidTelephone": "Ugyldigt telefonnummerformat.",
    "REDEEM_ERROR": {
      "_777": "Gavekortskoden er ikke gyldig. Kontrollere koden, og prøv igen.",
      "_786": "Ukendt kodevalideringsfejl. Kontroller koden, og prøv igen.",
      "_800": "Koden er allerede brugt",
      "_791": "Gavekortskoden kræver en PIN-kode. Indtast den tilknyttede pinkode, og prøv igen.",
      "_792": "PIN-koden er ikke gyldig. Kontroller pinkoden, og prøv igen.",
    },
    "success": "Gavekortskode aktiveret!",
    "DISCOUNT_CODE_FAILURE": "Rabatkoden kunne ikke anvendes, prøv venligst igen eller kontakt kundeservice.",
    "DISCOUNT_CODE_APPLIED": "Rabatkode anvendt.",
  },
  "ICONS": {
    "ARROW": "Pil højre",
    "CHEVRON": "Pil",
    "CART": "Indkøbskurv",
    "HEADPHONES": "Hovedtelefoner",
    "MAGNIFIER": "Forstørrelsesglas",
    "CROSS": "Kryds",
    "HAMBURGER": "Tre vandrette linjer (hamburgerikon)",
    "AVATAR": "Avatar",
    "DENMARK_FLAG": "Danmarks flag",
    "FINLAND_FLAG": "Finlands flag",
    "SWEDEN_FLAG": "Sveriges flag",
    "NORWAY_FLAG": "Norges flag",
  },
};
